import React from "react";
import "./privacyPage.scss";
import "../../utils/Styles/globalclasses.scss";

import Hero from "./components/hero/Hero";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import Footer from "../../components/footer/Footer";

const PrivacyPage = () => {
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
  return (
    <div>
      <Hero text={"Privacy Policy"} 
      // date={"Last Updated October 7, 2020"} 
      />
      <PrivacyPolicy />
      <Footer />
    </div>
  );
};

export default PrivacyPage;
